export const COOKIE_PARAM_NAME = {
    SESSION_UUID: 'sniff_session_uuid',
    REDIRECT: 'redirect_uri',
    REDIRECT_ONBOARD: 'redirect_onboard_uri',
    SUBSCRIBE: 'subscribe',
    USER: 'user',
    SNIFF_APP_DOWNLOAD_BANNER: 'sniff_app_download_banner',
    SNIFF_APP_SHOW_BANNER: 'sniff_app_show_banner',
    SMARTBANNER_INSTALLED: 'smartbanner-installed',
    SMARTBANNER_CLOSED: 'smartbanner-closed',
    FILTERS: 'filters',
    LANDING_PAGE: 'sniff_landing_page',
    SEARCH_FILTERS: 'search_filters',
    SEARCH_FILTERS_AVAILABILITY: 'search_filters_availability',
    SEARCH_FILTERS_LOCATION: 'search_filters_location',
    SEARCH_FILTERS_MISC: 'search_filters_misc',
    SIGN_UP_FROM: 'sniff_sign_up_from',
    VISIT_LIST_FILTERS: 'visit-list-filters',
    RESERVATION_LIST_FILTERS: 'reservation-list-filters',
    SPOT_DATA_FILTER: 'spot-data-filter',
    REDIRECT_GOOGLE_CAL: 'sniff_sync_google_redirect_uri',
    SNIFF_FIRST_CLICK: 'sniff_first_click_4028',
    USER_SURVEY: 'sniff_user_survey', // Boolean
    // Test
    FRONT_INTERSTITIAL_BEFORE_CALENDAR_FROM: 'sniff_interstitial_before_calendar_v2_5654_from',
    FRONT_NON_AUTH_REVIEW_V2: 'sniff_non_auth_review_v2_5671',
    FRONT_RECENT_REVIEWS: 'sniff_recent_reviews_6043',
    FRONT_LOCATION_SAVED: 'sniff_location_saved',
    LOCATION_MODAL_DISMISSED: 'sniff_location_modal_dismissed',
    FRONT_ADD_SPOT_PHOTO_REMINDER: 'sniff_add_spot_photo_reminder_7011',
    FRONT_REVISE_HOME: 'sniff_revise_homepage_7001',
};
